import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  CONTACT_PHONE_SEARCH_COLUMNS,

} from "./consts";
import { ContactPhoneSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const ContactSearchResults: React.FC<ContactPhoneSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onPhoneClick,
    onDeleteClick,
    onWhatsAppClick,
    onViberClick,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={CONTACT_PHONE_SEARCH_COLUMNS(t, onPhoneClick, onDeleteClick, onWhatsAppClick, onViberClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(ContactSearchResults);
